import { trackEvent } from './analytics';
import { trackUmamiEvent } from './umami';

/** Never include game names, keys, or participant details. */
export function trackRecentGame(event: 'recent_game_prompt_opened' | 'recent_game_continued', accountType: 'guest' | 'account'): void {
  const data = { account_type: accountType };
  try { trackEvent(event, data); } catch { /* Recovery must work without analytics. */ }
  try { void Promise.resolve(trackUmamiEvent(event, data)).catch(() => {}); } catch { /* Tracker unavailable. */ }
}
